import { useEffect } from "react";
import { useTenantStore } from "@/store/tenantStore";

/**
 * Fetches tenant configuration from the backend on app startup (once per mount).
 *
 * - Uses GET /v1/tenants/current — a public endpoint, no auth required.
 * - The tenant slug is derived from the browser hostname automatically.
 * - If the fetch succeeds, the store and localStorage cache are updated.
 * - If the fetch fails, the previously cached tenant (from localStorage) is
 *   kept, so the app continues to function offline or during API downtime.
 *
 * Place this hook at the top of App.tsx alongside the other init hooks
 * (useInactivityMonitor, useSessionManager, useThemeApplier).
 */
export function useTenantInit(): void {
  const isLoaded = useTenantStore((s) => s.isLoaded);
  const isLoading = useTenantStore((s) => s.isLoading);
  const fetchTenant = useTenantStore((s) => s.fetchTenant);

  useEffect(() => {
    // Only fetch if we haven't already loaded this session
    if (!isLoaded && !isLoading) {
      fetchTenant();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
